import React from 'react';
import Layout from './src/components/Layout';
import 'react-lazyload-youtube/dist/index.css'
import "./src/styles/global.css";

export const wrapPageElement = ({ element }) => <Layout>{element}</Layout>;